import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

function About() {
  const { lang } = useLanguage();

  return (
    <>
      <section className="page-hero">
        <h1>{t(lang, 'about_title_1')} <span className="gradient-text">{t(lang, 'about_title_2')}</span></h1>
        <p>{t(lang, 'about_subtitle')}</p>
      </section>

      <section className="section">
        <div className="container about-content">
          <h2>{t(lang, 'about_company_title')}</h2>
          <p>{t(lang, 'about_company_text')}</p>

          <h2>{t(lang, 'about_expertise_title')}</h2>
          <p>{t(lang, 'about_expertise_text')}</p>

          <h2>{t(lang, 'about_services_title')}</h2>
          <ul>
            <li>{t(lang, 'about_service_1')}</li>
            <li>{t(lang, 'about_service_2')}</li>
            <li>{t(lang, 'about_service_3')}</li>
            <li>{t(lang, 'about_service_4')}</li>
          </ul>

          <h2>{t(lang, 'about_ceo_title')}</h2>
          <p>
            {t(lang, 'about_ceo_text')}
            <br />
            <a href="https://www.linkedin.com/in/reddatabase/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" style={{ verticalAlign: 'middle', marginRight: '0.4rem' }}>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              {t(lang, 'about_linkedin')}
            </a>
          </p>

          <h2>{t(lang, 'about_publication_title')}</h2>
          <div className="book-section">
            <img src="/sql-injection-book.jpg" alt="SQL Injection Attacks and Defense" className="book-cover" />
            <div>
              <p>
                {t(lang, 'about_publication_text')} <strong>SQL Injection Attacks and Defense</strong> (Syngress).
              </p>
            </div>
          </div>

          <h2>{t(lang, 'about_speaker_title')}</h2>
          <p>
            BlackHat, DEFCON, BlueHat, Troopers, HITB, H2HC, SyScan, DOAG, DOAG SIG Security, PLOUG, ...
          </p>
        </div>
      </section>
    </>
  );
}

export default About;
